import { ILanguageNode } from '@packlink/translation-provider';
import { IAppState } from '@store/reducers';
import { ILanguageState } from '@store/reducers/languages';

export const getLanguage = (store: IAppState): ILanguageState => store.language;

export const getLocale = (store: IAppState): string => getLanguage(store).locale;

export const getAvailableLanguages = (store: IAppState): ILanguageNode[] => getLanguage(store).availableLanguages;
